import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;



new Vue({
    router,
    store,
    render: (h) => h(App),
    created() {
        //console.log(process.env);

        this.$store.dispatch("fillProductInfo").then(() => {
            this.$store.dispatch("fillMotifList").then(async() => {

                let criticalMotifs = [];
                //preloading first 2 cats of motifs
                for (let n = 0; n < 2; n++) {
                    for (let mi of this.$store.state.motifCatList[n].motifIndexes) {
                        criticalMotifs.push(this.$store.state.motifList[mi]);
                    }
                }
                //preloading product motifs if product is loaded
                if (this.$store.state.productMotifs != null) {
                    for (let pm of this.$store.state.productMotifs) {
                        criticalMotifs.push(pm.motifData);
                    }
                }
                await preloadAppImages(this.$store.state.productInfo);
                await preloadMotifs(criticalMotifs); //await critical motifs

                preloadMotifs(this.$store.state.motifList); //no await on rest of motifs

                this.$mount("#app");
                document.getElementById("init").classList.add("loaded");

                setTimeout(function () {
                    document.getElementById("init").remove();
                }, 1000);

            });
        });
    },
    mounted() {
        //To Load External Libs
        //let recaptchaScript = document.createElement('script')
        //recaptchaScript.setAttribute('src', 'https://localhost/Scripts/classes.js')
        //document.head.appendChild(recaptchaScript)
    },
});

const assetsRoot = "https://assets.needlepaint.com";

var imagesToPreLoad = [
    `${assetsRoot}/images/custom-needlepoint-belt-sizing.png`,
    `${assetsRoot}/images/custom-needlepoint-dog-collar-sizing.png`,
    `${assetsRoot}/images/custom-needlepoint-belt.jpg`,
    `${assetsRoot}/images/bg-main.png`,
    '//brewsterbelt.myshopify.com/cdn/shop/files/Brewster_standard_1.png?v=1707854127&width=280',
    `${assetsRoot}/images/stitches.png`
]


async function preloadAppImages(productInfo) {

    for (let po of productInfo.options[0].productOptions) {
        pushUnique(po.productOptionOverlay);
        pushUnique(`${assetsRoot}/images/product-overlays/option-${po.productOptionId}-1.png`)
        pushUnique(`${assetsRoot}/images/product-overlays/option-${po.productOptionId}-2.png`)      
    }
    pushUnique(`${assetsRoot}/images/product-overlays/product-${productInfo.productId}-1-outline.png`);
    pushUnique(`${assetsRoot}/images/product-overlays/product-${productInfo.productId}-2-outline.png`);
    try {
        await Promise.all(imagesToPreLoad.map(x => preloadImage(x)))
    } catch (error) {
        //
        console.log("Preload error");
    }
}

function pushUnique(value) {
    imagesToPreLoad.add ? imagesToPreLoad.add(value) : imagesToPreLoad.push(value);
}

async function preloadMotifs(motifs) {
    imagesToPreLoad = [];
    for (let m of motifs) {
        imagesToPreLoad.push(m.motifUrl);
    }
    try {
        await Promise.all(imagesToPreLoad.map(x => preloadImage(x)))
    } catch (error) {
        //
    }
}

const preloadImage = src =>
    new Promise((resolve, reject) => {
        const image = new Image()
        image.onload = resolve
        image.onerror = reject
        image.src = src
    })

